<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6QVLOQ/tc-custom/9780300227680.jpg?1718183147346" alt="This image is the cover for the book Presidents' Secrets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Presidents' Secrets
      </h1>
      <p class="bookDescription body article font2">
        <b>A “succinct and well-written” look at how presidents use secrecy to protect the nation, foster diplomacy—and gain power (<i>The Wall Street Journal</i>).</b><br/>  <br/> Ever since the nation’s most important secret meeting—the Constitutional Convention—presidents have struggled to balance open, accountable government with necessary secrecy in military affairs and negotiations. For the first one hundred and twenty years, a culture of open government persisted, but new threats and technology have long since shattered the old bargains. Today, presidents neither protect vital information nor provide the open debate Americans expect.<br/>  <br/> Mary Graham tracks the rise in governmental secrecy that began with surveillance and loyalty programs during Woodrow Wilson’s administration, explores how it developed during the Cold War, and analyzes efforts to reform the secrecy apparatus and restore oversight in the 1970s. Chronicling the expansion of presidential secrecy in the Bush years, Graham explains what presidents and the American people can learn from earlier crises, why the attempts of Congress to rein in stealth activities don’t work, and why presidents cannot hide actions that affect citizens’ rights and values.<br/>  <br/> “Engrossing . . . chilling and fascinating.” —<i>Publishers Weekly</i> (starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Graham
      </h2>
      
      <p class="authorDescription body article">Mary Graham is an American writer and co-director of the Transparency Policy Project at Harvard University's John F. Kennedy School of Government. She has written four books on the politics of public information. Presidents' Secrets: The Use and Abuse of Hidden Power, was published in 2017.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65edb34f